import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchJybes from './fetch-jybes'
import { IStatement } from '../../../model/statement'

export default async function unjybeStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.unjybe(statement).then((result: any) => {
        fetchJybes(context, statement)
    })

    return
}